<forge-list #searchTree navlist [ngStyle]="listStyles" [ngClass]="{'search-tree': isFirstLevel, 'provisional': isFirstLevel && isProvisional}" [role]="depth === 0 ? 'tree' : 'group'">
    <ng-container *ngFor="let child of children; let $index = index">
        <ng-template [isLeaf]="child" [isLeafElse]="branch" [isLeafIndex]="$index">
            <forge-list-item #nodeItem [selected]="isSelected(child)" (contextmenu)="onLeafContextMenu($event, child)"
                             (mouseup)="onLeafMouseup($event, child)" (mousedown)="onLeafMouseDown($event)"
                             role="treeitem" [ngClass]="getLeafNodeClasses(child)"
                             class="search-tree--item search-tree--leaf">
                <button (click)="onLeafClicked($event, child)" fxLayout="row" fxLayoutAlign="start center">
                    <span class="menu-key max-width-{{depth}}">{{child.Key}}</span>
                    <forge-tooltip *ngIf="showTooltip(child)" placement="bottom-left">{{child.Key}}</forge-tooltip>
                </button>
            </forge-list-item>
        </ng-template>
    </ng-container>
</forge-list>

<ng-template #branch let-node let-i="index">
    <forge-expansion-panel #topMenuItem [open]="isPanelExpandedInitial(node)" [attr.tree-path]="node.TreePath">
        <forge-list-item slot="header" [selected]="isSelected(node)" [ngClass]="getListItemClasses(node)"
                         class="search-tree--item" role="treeitem" [attr.aria-expanded]="isTreeNodeExpanded(node)">
            <button [id]="getAccessibleId(node, i)" fxLayout="row" fxLayoutAlign="start center"
                    (click)="onTreeClick(node)">
                <span class="menu-key max-width-{{depth}}">{{node.Key}}</span>
                <forge-tooltip *ngIf="showTooltip(node)" placement="bottom-left">{{node.Key}}</forge-tooltip>
            </button>
            <forge-open-icon slot="end" orientation="horizontal" rotation="half"></forge-open-icon>
        </forge-list-item>
        <div *ngIf="isTreeNodeExpanded(node)">
            <tree [dataSource]="node" [depth]="depth + 1" [filter]="filter" [selected]="selected"
                  (select)="onSelect($event)">
            </tree>
        </div>
    </forge-expansion-panel>
</ng-template>
